"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeItem = computeItem;
const errors_1 = require("../errors");
const cents_1 = require("../money/cents");
const menu_ventilation_1 = require("./menu-ventilation");
const resolve_1 = require("./resolve");
// F4 : jamais d'échec silencieux sur l'argent (spec §7) — un prix résolu ou
// une quantité invalides doivent faire échouer le calcul avant qu'ils ne
// contaminent baseTotal/extrasTotal.
function assertNonNegativeCents(value, label) {
    (0, cents_1.assertCents)(value, label);
    if (value < 0) {
        throw new errors_1.InvalidAmountError(`${label} doit être positif ou nul, reçu : ${value}`);
    }
}
function assertNonNegativeQuantity(value, label) {
    if (!Number.isInteger(value) || value < 0) {
        throw new errors_1.InvalidQuantityError(`${label} doit être un entier positif ou nul, reçu : ${value}`);
    }
}
function addShare(shares, tax, amount) {
    if (amount === 0)
        return;
    const existing = shares.get(tax.id);
    if (existing) {
        existing.amount += amount;
    }
    else {
        shares.set(tax.id, { tax, amount });
    }
}
function computeItem(item, mode) {
    const shares = new Map();
    const extras = [];
    const unitPrice = (0, resolve_1.resolvePrice)(item.pricing, mode);
    assertNonNegativeCents(unitPrice, 'computeItem.unitPrice');
    assertNonNegativeQuantity(item.quantity, 'computeItem.quantity');
    const itemTax = (0, resolve_1.resolveTax)(item.taxes, mode);
    // Prix de base : uniquement le prix de l'item, plus ses suppléments
    // d'étape depuis R4 — ceux-ci sont taxés à leur propre taux et rejoignent
    // les extras, pas le prix de base (contrairement à la v2 d'origine).
    const baseTotal = unitPrice * item.quantity;
    // Ventilation à l'UNITÉ puis × quantité : chaque part reste un multiple de
    // la quantité, donc le PU de chaque ligne fiscale est entier.
    const unitParts = item.kind === 'pack'
        ? (0, menu_ventilation_1.ventilerPrixDeMenu)(unitPrice, item.components ?? [], itemTax)
        : [{ tax: itemTax, amount: unitPrice }];
    const baseParts = unitParts.map((part) => ({
        tax: part.tax,
        unitAmount: part.amount,
        amount: part.amount * item.quantity,
    }));
    for (const part of baseParts)
        addShare(shares, part.tax, part.amount);
    let extrasTotal = 0;
    if (item.kind === 'pack') {
        for (const supplement of item.stepSupplements) {
            assertNonNegativeCents(supplement.price, 'computeItem.stepSupplement.price');
            assertNonNegativeQuantity(supplement.quantity, 'computeItem.stepSupplement.quantity');
            const amount = supplement.price * supplement.quantity * item.quantity;
            extrasTotal += amount;
            addShare(shares, supplement.tax, amount);
            if (amount > 0) {
                extras.push({ referenceId: supplement.referenceId, amount, tax: supplement.tax });
            }
        }
    }
    for (const option of item.options) {
        const optionPrice = (0, resolve_1.resolvePrice)(option.pricing, mode);
        assertNonNegativeCents(optionPrice, 'computeItem.option.price');
        assertNonNegativeQuantity(option.quantity, 'computeItem.option.quantity');
        const optionTax = (0, resolve_1.resolveTax)(option.taxes, mode);
        const amount = optionPrice * option.quantity * item.quantity;
        extrasTotal += amount;
        addShare(shares, optionTax, amount);
        if (amount > 0) {
            extras.push({ referenceId: option.referenceId, amount, tax: optionTax });
        }
    }
    return {
        referenceId: item.referenceId,
        kind: item.kind,
        quantity: item.quantity,
        unitPrice,
        baseTotal,
        extrasTotal,
        subtotal: baseTotal + extrasTotal,
        tax: itemTax,
        baseParts,
        vatShares: [...shares.values()],
        extras,
    };
}
